import { render, staticRenderFns } from "./purchase-change-product.vue?vue&type=template&id=45db428a&scoped=true&"
import script from "./purchase-change-product.vue?vue&type=script&lang=js&"
export * from "./purchase-change-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db428a",
  null
  
)

export default component.exports